import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ContactNoteDocuments {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include respond-to(sm) {
      flex-direction: column;
    }
  }

  .ContactNoteDocument {
    display: flex;
    align-items: center;
    margin-top: 10px;
    flex: 50%;

    &:hover {
      :global(.ActionsButton) {
        display: block;
      }
    }

    &__icon {
      max-width: 32px;
      width: 100%;
      margin-right: 8px;
    }

    &__name {
      border-bottom: 1px solid transparent;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        border-bottom: 1px solid;
      }
    }

    :global(.ActionsButton) {
      display: none;

      @include respond-to(sm) {
        display: block;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .ContactNoteDocument {
      &__name {
        color: ${colors.black.hex} !important;

        &:hover {
          border-bottom-color: ${colors.black.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
